<template>
 <div>
 <table style="position: absolute;" width="100%"  :height="this.windowSize.height-8"  :max-height="this.windowSize.height-8" >
  
  <tr max-height="48px" height="48px"  >
      
<ContenidoBase 
  :titulo="'Reporte Ventas de productos con descuento'"
  :descripcion="'Imprime ventas con descuento'"
   :EstadoBtn="EstadoBtn"
   @abrirBarraTablaDinamica="abrirTabla"
   @MethodNuevo="newwnuevo"
   @MethodGuardar="save"
   @MethodEliminar="remove"
   @MethodAnular="anular"
   @MethodImprimir="imprimirList"
/>
    </tr>
    
    
    <tr>
<!-- BarraPrimaria --------------------------------------------------------------------------------->
      <td width="109" :max-height="this.windowSize.height-96" v-show="BarraTablaDinamicaAprir">

         <div class="overflow-y-auto " v-bind:style="{  'max-height':this.windowSize.height-96+ 'px' , 'max-width': '325px', 'width': '325px'  }">
        
        <v-tooltip left>
          <template v-slot:activator="{ on }">
              <center>
              <v-btn-toggle>
                <v-btn
                  small
                  color="yellow accent-4"
                  @click.prevent="actualiza_tb_ver"
                >
                  <i style="font-size: 25px;" class="fa fa-eye"> </i> ver</v-btn
                >
                <v-btn
                  small
                  dark
                  color="deep-purple accent-2"
                  @click.prevent="notifi('Seguro que desea nuevo', 'n')"
                >
                  <i style="font-size: 25px;" class="fa fa-print"> </i>
                  Listado</v-btn
                >
              </v-btn-toggle>
            </center>
            <!-- <BarraBusqueda2
              :url="
                $hostname + $hName + '/services/tipocliente/findalltipoclientes'
              "
              :nombre="'Tipo de Clientes'"
              :headers="headers"
              :slotname="'item.descripcion'"
              :emitnombre="'emitReportesMedicosVendedores'"
              :SeachNombre="'Búsqueda por descripcion '"
              :slotlist="slotlist"
            /> -->
          </template>
        </v-tooltip>

      </div>
      </td>
<!-- fn BarraPrimaria ---------------------------------------------------------------------------------->
<!-- contenido central ------------------------------------------------------------------------------ -->
      <td :max-height="this.windowSize.height-96" >
        <v-app id="inspire" class="overflow-y-auto " v-bind:style="{  'max-height':this.windowSize.height-96+ 'px' }">
 <!-- Formulario-Reporte Medicos Vendedores-->

 <v-container >
  <v-card color="grey lighten-3">

<v-toolbar
        flat
        color="#BDBDBD"
        dense
        style="border: 1px solid #000000;"
      >
        
  
 <v-avatar tile  size="45"  >
      <img
        src="@/assets/iconos_micromarket/custom-reports.png"
        alt="Reporte"
      >
    </v-avatar>

    
<span class="font-weight-light" style="font-size: 20px;" >   Ventas de productos con descuento </span >

  <!-- <v-toolbar-title    class="font-weight-light"> Reporte Producción de boletos por unidades</v-toolbar-title > -->
   <!-- style="color:white;" -->
    <!-- <i class=""> </i> -->

        <!-- <v-spacer></v-spacer> -->
        <!-- <v-btn
          color="grey darken-4"
          fab
          small
          @click="cerrarmodalcuenta"
        >
         <i  style="font-size: 20px; color:white;" class="fa fa-close"></i>
        </v-btn> -->
      </v-toolbar>
           
<hr>

  <v-container style="border: 1px solid #000000;">
  <v-form ref="form" @submit.prevent=""  v-model="valid" lazy-validation>
              <v-row >



<!-- columna 1 -->
<v-col cols="12" md="6" sm="6" class="py-0 my-0 ">
  <!-- -----------------------------  desde  -->
<v-text-field
        dense
        outlined
        type="date"  
        label="Desde:"
         :rules="[$rules.required]"
        v-model="descuentoFabricante.desde"
        class="fontSize13" 
        @blur="BlurDesde"
        >
                <template v-slot:prepend>
                  <i style="font-size: 20px;" class="fa fa-calendar"></i>
                </template>

</v-text-field>
</v-col>
<!-- fn columna 1-->


<!-- columna 2 -->
<v-col cols="12" md="6" sm="6" class="py-0 my-0 ">
<!-- -----------------------------  Hasta  -->
<v-text-field
        dense
        outlined
        type="date" 
         :rules="[$rules.required]" 
        label="Hasta:"
        v-model="descuentoFabricante.hasta"
        @blur="BlurHasta"
        class="fontSize13" 
        >
                <template v-slot:prepend>
                  <i style="font-size: 20px;" class="fa fa-calendar"></i>
                </template>

</v-text-field>
</v-col>
<!-- fn columna 2 -->
         
<!-- columna 3 -->
<v-col cols="12" md="6" sm="6" class="py-0 my-0 ">
<!-------------------------------------------------- Producto -->

 <v-combobox
                          ref="productoCombo"
                          v-model="descuentoFabricante.producto"
                          :items="Rproducto"
                          autocomplete="off"
                          dense
                          hide-details
                          item-text="codProDesc"
                          label="Productos:"
                          no-filter
                          outlined
                          @blur="SelctCbProduc"
                          @focus="CargarRproducto"
                          @keyup="CbFilProducto"
                        >
                          <template slot="item" slot-scope="item">
                              <span style="display:none;">{{
                                  item.item.codProDesc = `${item.item.productos.codigo} - ${item.item.productos.descripcion.trim()} ${item.item.unidades.descripcion.trim()} `
                                }}</span>
                            <span
                              class="fontSize13"><b>{{
                                item.item.productos.codigo
                              }}</b> - {{
                                item.item.productos.descripcion.trim()
                              }} <b>{{ item.item.unidades.descripcion.trim() }}</b> </span>
                          </template>

                          <template v-slot:selection="{ attrs, item, parent, selected }">
                              <span v-if="item.hasOwnProperty('productos')"
                                    class="fontSize13 colorNombre"> <b>{{
                                  item.productos.codigo
                                }}</b> - {{ item.productos.descripcion }} {{ item.unidades.descripcion }}  </span>
                          </template>
                          <template v-slot:prepend>
                            <i
                              class="fa fa-shopping-cart"
                              style="font-size: 20px;"
                              
                            ></i>
                          </template>
                        </v-combobox>
</v-col>
<!-- fn columna 3 -->

<!-- columna 4 -->
<v-col cols="12" md="6" sm="6" class="py-0 my-0 ">
 <v-combobox
                          v-model="descuentoFabricante.fabricante"
                          :items="RFabricante"
                          autocomplete="off"
                          dense
                          item-text="nombre"
                          label="Fabricante:"
                          outlined
                          @blur="SelctCbFabricantes"
                          @focus="CargarRFabricantes"
                        >
                          <template v-slot:prepend>
                            <i
                              class="fa fa-wrench"
                              style="font-size: 20px;"
                            ></i>
                          </template>
 </v-combobox>
</v-col>
<!-- fn columna 4 -->

<!-- columna 5 -->
<v-col cols="12" md="6" sm="6" class="py-0 my-0 ">
  <!------------------------------------------ Descuento -->
                      <AutoNumeric v-model="descuentoFabricante.porcientoMini" dense label="Descuento Minimo:" outlined>
                        <template v-slot:prepend>
                          <i class="fa fa-percent" style="font-size: 20px"></i>
                        </template>
                      </AutoNumeric>

</v-col>
<!-- fn columna 5 -->

<v-col cols="12" md="12" sm="12" class="py-0 my-0 ">
  <span>
                          <b>Nota:</b><span style="color: #C62828;"> EL REPORTE VA A GENERAR LAS VENTAS CON DESCUENTO MAYOR Al VALOR DIGITADO EN EL CAMPO DESCUENTO MINIMO.</span>
                        </span>
</v-col>

              </v-row>
            </v-form>
       </v-container>

<hr>

<ModalReporteFiltros
 ref="ModRepFilt"
@DataReporteBasico="DDataReporteBasico"
:Datos="descuentoFabricante"
/>



  </v-card>
 </v-container>
 <!-- fn Formulario- Reporte Medicos Vendedores-->
        </v-app> 
      </td>
<!-- fn contenido central ------------------------------------------------------------------------------------->
<!-- BarraSecundaria ------------------------------------------------------------------------------------------>
      <td width="109" :max-height="this.windowSize.height-96" v-show="BarraSecundariaAprir" >

 <div  class="overflow-y-auto " v-bind:style="{  'max-height':this.windowSize.height-96+ 'px' , 'max-width': '325px', 'width': '325px' }">
        
<!--         
        <BarraBusqueda2
              :url="$hostname + $hName + '/services/caja/findAll'"
              :nombre="'Cajas'"
              :headers="headers"
              :slotname="'item.descripcion'"
              :emitnombre="'emitCaja'"
              :slotlist="slotlist"
              :SeachNombre="'Búsqueda por descripción caja'"
            /> -->
</div>

      </td>
<!-- fn BarraSecundaria --------------------------------------------------------------------------------------->



    </tr>
  </table>
<!-- Modales -------------------------------------------------------------------------------------------------->
  <!-- ------------------------------------------------------ tb-data-->
    <v-dialog
      label="myAlert"
      v-model="acti_tb_data"
      persistent
      max-width="100%"
      max-height="100%"
      transition="fab-transition"
    >
      <v-card>
        <v-toolbar flat color="#BDBDBD">
          <i style="font-size: 20px;" class="fa fa-file-pdf-o"></i>
          <v-toolbar-title class="font-weight-light"> REPORTE </v-toolbar-title>
          <i style="font-size: 20px;" class="fa fa-file-pdf-o"> </i>

          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-4"
            fab
            small
            @click="acti_tb_data = !acti_tb_data"
          >
            <i style="font-size: 20px; color:#dd4b39;" class="fa fa-close"></i>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-card>
            <v-card-title>
              <v-text-field
                v-model="search"
                @keyup="filtro"
                label="Buscar"
                single-line
                hide-details
              >
                <template v-slot:prepend-inner>
                  <i style="font-size: 35px;" class="fa fa-search"></i>
                </template>
              </v-text-field>
            </v-card-title>

            <v-data-table
              :headers="slotHtabla"
              dense
              :items="list"
              :search="search"
              @click:row="datostabla"
            >
              <template v-slot:item.porciento="props">
                <span>{{ currencyFormatter(props.item.porciento) }}</span>
              </template>
            </v-data-table>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------ Elim_notif-->
    <v-dialog
      label="myAlert"
      v-model="Elim_notif.estado"
      persistent
      max-width="350"
      transition="fab-transition"
    >
      <template justify="center" v-slot:activator="{ on }"></template>

      <v-card>
        <v-card-title>
          <h4>
            <i style="font-size: 28px;" class="fa fa-warning"></i>
            CONFIRMACION
            <i style="font-size: 28px;" class="fa fa-warning"></i>
          </h4>
        </v-card-title>
        <hr />

        <v-card-text>
          <h5>{{ Elim_notif.nombre }}</h5>
        </v-card-text>

        <hr />
        <v-card-actions>
          <v-btn
            @click.prevent="
              eliminar(), (Elim_notif.estado = !Elim_notif.estado)
            "
            small
          >
            <i style="font-size: 20px;" class="fa fa-check"></i> Si
          </v-btn>

          <v-btn @click.prevent="Elim_notif.estado = !Elim_notif.estado" small>
            <i style="font-size: 20px;" class="fa fa-ban"></i> No
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------  fn Elim_notif -->

    <!------------otras funciones---------------->
    <v-snackbar
      v-model="aalert.estado"
      :color="aalert.color"
      style="margin-top: 20%;"
      :vertical="true"
      :timeout="120000"
      top="top"
    >
      {{ aalert.nombre }}
      <v-btn dark text @click="aalert.estado = false">Close</v-btn>
    </v-snackbar>

<!-- fn Modales ----------------------------------------------------------------------------------------------->


  </div>
</template>

<script>
import { EventBus } from "../../event-bus";
import BarraBusqueda2 from "../../components/BarraBusquedaDinam";
import ContenidoBase from "../../components/ContenidoBase";
import ModalReporteFiltros from "../../components/ModalReporteFiltros2";
import AutoNumeric from "../../components/AutoNumericNuevo"
import { currencyFormatter,
  FormatoFecha,
  HoraFormatter,
  HoraFormatter2,
  RedondeoValor,
  RedondeoBasico,
  RedondeoValorCantRed,
  fechaNueva,
  getParamFecha
} from "@/js/Funciones.js";
export default {
  components: {
    BarraBusqueda2,
    ContenidoBase,
    ModalReporteFiltros,
    AutoNumeric

  },
  created() {
    var json = { 
      titulo: "Reporte Medicos / Vendedores",
      descripcion: "Imprime las Reporte Medicos / Vendedores.",
      save: false,
      eliminar: false,
      anular: false,
      nuevo: false,
      imprimir: false,
      accion: [ 

        "ReportesMedicosVendedoresNew",
        "ReportesMedicosVendedoresSave",
        "ReportesMedicosVendedoresRemove",
        "ReportesMedicosVendedoresAnular",
        "ReportesMedicosVendedoresPrintList"
      ], 
    };
    EventBus.$emit("anularBotonesAccion", json);
  },
  // mounted-carga de inicio
  mounted() {
    EventBus.$on("abrirMenuizquierdo", this.abrirTabla);
    // EventBus.$on("abrirMenuizquierdo", this.abrirTabla2);
    // EventBus.$on("ReportesMedicosVendedoresNew", this.new);
    // EventBus.$on("ReportesMedicosVendedoresSave", this.save);
    // EventBus.$on("ReportesMedicosVendedoresRemove", this.remove);
    // EventBus.$on("ReportesMedicosVendedoresAnular", this.remove);
    // EventBus.$on("ReportesMedicosVendedoresPrintList", this.imprimirList);
    EventBus.$on("emitReportesMedicosVendedores", this.datostabla);
   

    EventBus.$on("onResize", this.onResize);

 this.$refs.ModRepFilt.CrearObjecto=this.validarObjecto;

  },
    // fn mounted-carga de inicio

  data:()=>  ({
/*
Ventas con descuento
ventas de productos con descuento:
NOTA: EL REPORTE VA A GENERAR LAS VENTAS CON DESCUENTO MAYOR Al VALOR DIGITADO EN EL CAMPO DESCUENTO MINIMO
*/ 
      
      Rproducto:[],
      RFabricante:[],
      windowSize:{width:"auto", height:"auto"},
      descuentoFabricante: {
        nombre:'ventas de productos con descuento',
        UrlImprimir: '/reportes-pv/ImprimirListVentasProductosDescuento', 
        UrlExel: '/reportes-pv/ExcelListVentasProductosDescuento', 
        UrlCorreo: '/reportes-pv/CorreoListVentasProductosDescuento',
        desde: fechaNueva(),
        hasta: fechaNueva(),
        producto:null,
        fabricante:null,
        porcientoMini:0,
        //fechaCreacion: new,
      //  fechaModificacion: "", 
      },
EstadoBtn:{ 
        BarraTablaDinamicaAprir:false,
        nuevo:false,
        guardar:false,
        eliminar:false,
        anular:false,
        imprimir:false,
        vercuenta:false,
        guardartemporal:false,
        restaurartemporal:false,
        importarDato:false,
        cargarProducto:false,
        ImprimirproductoInv:false,
        },
     
      text: "",
      valid: true,
     BarraTablaDinamicaAprir: false,
      BarraSecundariaAprir: false,

      headers: [{ text: "Tipo Clientes", value: "descripcion" }],

      slotlist: [
        { dt0: "codigo", dt1: null, dt2: null, dt3: 1, dt4: "Código:" },
        {
          dt0: "descripcion",
          dt1: null,
          dt2: null,
          dt3: 1,
          dt4: "Descripcion:"
        },
        { dt0: "activo", dt1: null, dt2: null, dt3: 0.1, dt4: "Desactivo" },
      ],

      slotHtabla: [
        { text: "Código", value: "codigo" },
        { text: "Descripcion", value: "descripcion" }
      ],

      list: [],
      search: "",
      acti_tb_data: false,
      Elim_notif: {
        estado: false,
        nombre: "¿Seguro que desea anular este registro?"
      },

      aalert: {
        estado: false,
        color: null
      },
    
    }),


  //   destroyed() {
  //     location.reload();
  //   },
  methods: {
    currencyFormatter,
  FormatoFecha,
  HoraFormatter,
  HoraFormatter2,
  RedondeoValor,
  RedondeoBasico,
  RedondeoValorCantRed,
  fechaNueva,
  getParamFecha,
onResize(e){

console.log("imprii ")

console.log(e)
this.windowSize=e


},

    abrirTabla() {
      this.BarraTablaDinamicaAprir = !this.BarraTablaDinamicaAprir;

    },
   
    datostabla(e) {

      this.descuentoFabricante = e;
      this.acti_tb_data=false
    },
    save() { },
    remove() {},
    eliminar() {},
    anular() {},
    imprimirList() {},
    // Retorna los datos del componente ModalReporteFiltros
    DDataReporteBasico(){},

   // Creación de una cláusula where para una consulta.
    validarObjecto(){

      var fecdesde=this.descuentoFabricante.desde
      var fechasta=this.descuentoFabricante.hasta


var where=" fv.activada = TRUE "
where+=` and fv.fecha >= '${fecdesde}' and fv.fecha  <='${fechasta}'`
var condicion=`DESDE: ${this.FormatoFecha(this.descuentoFabricante.desde)}                    HASTA: ${this.FormatoFecha(this.descuentoFabricante.hasta)}  `;

  where+=` and fd.descuento >= ${this.descuentoFabricante.porcientoMini} `

  if(this.descuentoFabricante.fabricante!=null){ 
  where+= ` and fa.codigo= ${this.descuentoFabricante.fabricante.codigo}` 
  condicion += `                 FABRICANTE: ${this.descuentoFabricante.fabricante.nombre.trim().toUpperCase()}                     `
  }

   if(this.descuentoFabricante.producto!=null){ 
  where+= ` and fd.producto= ${this.descuentoFabricante.producto.productos.codigo}` 
  condicion += `                 PRODUCTO: ${this.descuentoFabricante.producto.productos.descripcion.trim().toUpperCase()}                     `
  }


  condicion += `                 %DESC MINIMO: ${this.descuentoFabricante.porcientoMini}                    `



//this.descuentoFabricante.nombre="REPORTE MEDICOS"





this.descuentoFabricante.where=where
this.descuentoFabricante.condicion=condicion


},


    newwnuevo() {
      (this.descuentoFabricante = {
        activo: true,
        borrado: false,
        codigo: 0,
        descripcion: "",
        descripcionOriginal: "",
        fechaCreacion: "",
        fechaModificacion: "",
        usuarioCreacion: "",
        usuarioModificacion: "",
        cliente:null
      }),
        EventBus.$emit("actualizaBarraBusqueda2");
    },


// Un método que se llama cuando el campo de entrada pierde el foco y valida si es nulo el compo
//si lo es coloca la fecha actual.
BlurDesde(){
if(this.descuentoFabricante.desde.toString().length==0){
  this.descuentoFabricante.desde=this.fechaNueva()
}
 },

// Un método que se llama cuando el campo de entrada pierde el foco y valida si es nulo el compo
//si lo es coloca la fecha actual.
 BlurHasta(){
if(this.descuentoFabricante.hasta.toString().length==0){
  this.descuentoFabricante.hasta=this.fechaNueva()
}
 },


 CargarRproducto() {
      this.$axios.get(this.$hostname + this.$hName +
        "/unidades-productos/*/false/buscar",
        { headers: this.$store.getters.GetheadersAxios },).then(res => { this.Rproducto = res.data})
    },

    CbFilProducto(e) {
      if (e.target.value.length >= 0) {

        this.$axios
          .get(this.$hostname +
            this.$hName +
            "/unidades-productos/" + (e.target.value === "" ? "A" : e.target.value.trim().replaceAll("/", "*-S-*")) + "/false/buscar",
            { headers: this.$store.getters.GetheadersAxios },
          )
          .then(res => {
            this.Rproducto = res.data
          })
      }
    },


SelctCbProduc(){
  var _this = this;
setTimeout(function () {
  if (_this.descuentoFabricante.medico == null) {
    _this.descuentoFabricante.medico = "";
  }

  if (!_this.descuentoFabricante.medico.hasOwnProperty('codigo')) {
    _this.descuentoFabricante.medico = "";
    _this.descuentoFabricante.medico = null;
    return;
  }
}, 300);

},


CargarRFabricantes() {
      this.$axios.get(this.$hostname + this.$hName + "/fabricante/activo",
          {headers: this.$store.getters.GetheadersAxios,},)
          .then(res => this.RFabricante = res.data)
          .catch()
    },


SelctCbFabricantes(){
var _this = this;
setTimeout(function () {
  if (_this.descuentoFabricante.fabricante == null) {
    _this.descuentoFabricante.fabricante = "";
  }

  if (!_this.descuentoFabricante.fabricante.hasOwnProperty('codigo')) {
    _this.descuentoFabricante.fabricante = "";
    _this.descuentoFabricante.fabricante = null;
    return;
  }
}, 300);
},

    alerta(e, l) {
      if (l == "bien") {
        (this.aalert.estado = true),
          (this.aalert.color = "success"),
          (this.aalert.nombre = e);

        this.newwnuevo();
      }

      if (l == "error") {
        (this.aalert.estado = true),
          (this.aalert.color = "error"),
          (this.aalert.nombre = e);

        this.ejecucion = false;
      }
    },




    actualiza_tb_ver() {
      this.acti_tb_data = !this.acti_tb_data;
      this.filtro();
    },

    async filtro() {
      await this.$axios
        .post(this.$hostname + this.$hName + "/services/tipocliente/findalltipoclientes", {
          usuario:JSON.parse(JSON.stringify(this.$user)) 
        })
        .then(res => {
          this.list = res.data;
        });
    }
  }
};
</script>

<style></style>
